import { useState } from "react";
import { jokes, barrageItems } from "@/mocks/guaData";

export default function JokesBarrage() {
  const [up, setUp] = useState<Set<string>>(new Set());

  const toggle = (id: string) => {
    setUp((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <>
      {/* 弹幕广场 */}
      <section id="barrage" className="bg-background-50 py-14 md:py-20">
        <div className="container-page">
          <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-5 py-10 md:px-10 md:py-14">
            <div className="pointer-events-none absolute inset-0 opacity-30">
              <div className="absolute left-10 top-8 text-4xl">🍉</div>
              <div className="absolute right-16 top-14 text-3xl">😂</div>
              <div className="absolute bottom-10 left-1/4 text-3xl">🤣</div>
            </div>
            <div className="relative text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-500/20 px-4 py-1.5 text-sm font-bold text-background-100">
                <i className="ri-chat-smile-2-line"></i>
                实时弹幕墙
              </span>
              <h2 className="heading-font mt-5 text-2xl text-background-50 md:text-3xl">
                弹幕区的快乐，你懂的
              </h2>
              <div className="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
                {barrageItems.map((b) => (
                  <div
                    key={b.id}
                    className="rounded-xl border border-background-200/20 bg-background-50/10 px-4 py-3 text-left text-sm backdrop-blur"
                    style={{ borderColor: `${b.color}55` }}
                  >
                    <i
                      className="ri-user-smile-line mr-1.5"
                      style={{ color: b.color }}
                    ></i>
                    <span className="text-background-100">{b.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 神梗段子 */}
      <section id="jokes" className="bg-background-100 py-14 md:py-20">
        <div className="container-page">
          <div className="mb-6 flex items-end justify-between gap-4">
            <div>
              <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
                💬 神梗段子合集
              </h2>
              <p className="mt-2 text-sm text-foreground-500">
                网友玩梗造段，一个比一个能说。欢迎对号入座，笑出声不算输。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {jokes.map((j) => (
              <article
                key={j.id}
                className="animate-pop flex flex-col rounded-2xl bg-background-50 p-6 transition-transform hover:-translate-y-1"
              >
                <div className="mb-3 flex items-center justify-between">
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
                    {j.category}
                  </span>
                  <span className="text-xs text-foreground-500">
                    来自 @{j.author}
                  </span>
                </div>
                <h3 className="heading-font text-lg text-foreground-900">
                  {j.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-6 text-foreground-700">
                  {j.text}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <button
                    type="button"
                    onClick={() => toggle(j.id)}
                    className={`flex cursor-pointer items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-bold transition-colors ${
                      up.has(j.id)
                        ? "bg-primary-100 text-primary-700"
                        : "text-foreground-600 hover:bg-background-100"
                    }`}
                  >
                    <i
                      className={`${
                        up.has(j.id) ? "ri-thumb-up-fill" : "ri-thumb-up-line"
                      }`}
                    ></i>
                    给这个段子打 call
                  </button>
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-fire-line text-primary-500"></i>
                    {j.likes} 人在笑
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}